import { Injectable } from "@angular/core";
import { UtilsService } from "./utils.service";
import { ContractService } from "./contract.service";
import { UserService } from "./user.service";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class ManageCandidateContractService {
  public data: any = {
    level: "",
    role: null,
    start_date: null,
    end_date: null,
    trial: "",
    program: "full time",
    contract: null,
    gross_monthly_12: 0,
    net_monthly_12: 0,
    net_monthly_13: 0,
    total_net_monthly_13: 0,
    salary_yearly_gross: 0,
    total_daily: 0,
    bonus: 0,
    ticket_card: null,
    ticket_month_number: 0,
    ticket_value: 0,
    ticket_type: "fisso",
    ticket_total: 0,
    tutor_hash: null,
    record_type: "desiderata",
    resignation_url: null,
    closed_at: null,
    closed_reason: null,
  };

  private economic_fields: string[] = ["gross_monthly_12", "net_monthly_12", "net_monthly_13", "total_net_monthly_13", "salary_yearly_gross", "total_daily", "bonus", "ticket_total"];

  public levels_for_select: any = [];

  private levels_list: any = [];

  public costs: any = [];

  public current_lvl: any;

  public next_lvl: any;

  public tutors: any = [];

  public typeIsApprendistato: boolean = false;

  public contractDuration: number = 0;

  public typeIsStage: boolean = false;

  public typeIsVatNumber: boolean = false;

  constructor(
    private _utils: UtilsService,
    private _contractService: ContractService,
    private _toastService: ToastrService,
    private _userService: UserService,
  ) {}

  public async init(saved_data: any = null) {
    this.costs = await this._contractService.getCosts();
    this.tutors = await this._userService.getList("employee");
    await this._contractService.getLevels();

    if (saved_data) {
      const data: any = JSON.parse(JSON.stringify(saved_data));

      delete data.resignation_url;
      delete data.file_dimissional;
      delete data.role_name;

      this.data = { ...data };

      this.data.bonus = Number(data.bonus);
      this.data.total_daily = Number(data.total_daily);
      this.data.net_monthly_12 = Number(data.net_monthly_12);
      this.data.net_monthly_13 = Number(data.net_monthly_13);
      this.data.salary_yearly_gross = Number(data.salary_yearly_gross);
      this.data.total_net_monthly_13 = this.data.net_monthly_13 + this.data.bonus;

      this.data.bonus = Number(data.bonus);
      this.typeIsApprendistato = this.data.contract_name === "Apprendistato";
      this.typeIsStage = this.data.contract_name === "Stage";
      this.typeIsVatNumber = this.data.contract_name === "Partita IVA";
      this.data.ticket_value = Number(this.data.ticket_value);
      this.data.ticket_total = this.data.ticket_value * 20;

      if (this.typeIsApprendistato) {
        this.current_lvl = this.costs.find((cost: any) => cost.is_apprendistato === 1 && cost.year == 3 && cost.level === this.data.level);
      } else if (this.typeIsStage || this.typeIsVatNumber) {
        this.current_lvl = {
          level: "",
          role: data.role,
          start_date: null,
          end_date: null,
          trial: "",
          program: data.program,
          contract: data.contract,
          gross_monthly_12: data.gross_monthly_12,
          net_monthly_12: data.net_monthly_12,
          net_monthly_13: data.net_monthly_13,
          total_net_monthly_13: data.total_net_monthly_13,
          salary_yearly_gross: data.salary_yearly_gross,
          total_daily: data.total_daily,
          bonus: 0,
          ticket_card: null,
          ticket_month_number: 0,
          ticket_value: 0,
          ticket_type: "fisso",
          ticket_total: 0,
          tutor_hash: null,
        };
      } else {
        this.current_lvl = this.costs.find((cost: any) => cost.is_apprendistato === 0 && cost.level === this.data.level);
      }

      if (this.data.desired_total_daily) {
        this.current_lvl.total_daily = this.data.desired_total_daily;
        if (this.data.bonus > 0) {
          this.current_lvl.total_daily -= this.data.bonus / 20;
        }
      }

      this.addDots();

      if (!this.typeIsStage && !this.typeIsVatNumber) {
        this.getLevels();
      }
    }
  }

  getLevelsData() {
    const name: string = this.data.level;
    let currentLvl: any = null;
    let nextLvl: any = null;
    switch (name) {
      case "B3":
        const b3List: any = this.levels_list.filter((c: any) => c.level === name);
        currentLvl = b3List[0];
        nextLvl = b3List[b3List.length - 1];
        break;
      default:
        currentLvl = this.levels_list.find((c: any, index: number) => {
          if (c.level === name) {
            nextLvl = this.levels_list[index + 1];
            return c;
          }
        });
        break;
    }

    for (let key of Object.keys(currentLvl)) {
      if (typeof currentLvl[key] === "string" && this.economic_fields.includes(key)) {
        currentLvl[key] = Number(currentLvl[key]);
      }
    }

    for (let key of Object.keys(nextLvl)) {
      if (typeof nextLvl[key] === "string" && this.economic_fields.includes(key)) {
        nextLvl[key] = Number(nextLvl[key]);
      }
    }

    return { currentLvl, nextLvl };
  }

  private addDots() {
    Object.keys(this.data).map((key: string) => {
      if (this.data[key] && typeof this.data[key] !== "string" && (this.economic_fields.includes(key) || ["bonus", "ticket_total"].includes(key))) {
        this.data[key] = this._utils.addDotsToNumber(this.data[key]);
      }
    });
  }

  async resetData(exclude_role: boolean = false) {
    this.data.level = null;
    this.data.start_date = null;
    this.data.end_date = null;
    this.data.trial = null;
    this.data.program = "full time";
    this.data.contract = null;
    this.data.gross_monthly_12 = 0;
    this.data.net_monthly_12 = 0;
    this.data.net_monthly_13 = 0;
    this.data.total_net_monthly_13 = 0;
    this.data.salary_yearly_gross = 0;
    this.data.total_daily = 0;
    this.data.total_daily_with_bonus = 0;
    this.data.bonus = 0;
    this.data.ticket_card = null;
    this.data.ticket_month_number = 0;
    this.data.ticket_value = 0;
    this.data.ticket_type = "fisso";
    this.data.ticket_total = 0;
    this.data.tutor_hash = "";
    this.data.record_type = "desiderata";
    this.data.resignation_url = null;
    this.data.closed_at = null;
    this.data.closed_reason = null;

    if (!exclude_role) {
      this.data.role = null;
    }

    this.costs = await this._contractService.getCosts();
  }

  getLevels() {
    const isApprendistato: number = this.typeIsApprendistato ? 1 : 0;
    this.levels_list = this.costs.filter((lvl: any) => lvl.is_apprendistato === isApprendistato);

    if (isApprendistato) {
      this.levels_list = this.levels_list.filter((lvl: any) => lvl.year === 3);
    }

    this.levels_list = this.levels_list.sort((a: any, b: any) => {
      a = parseFloat(a.salary_yearly_gross);
      b = parseFloat(b.salary_yearly_gross);
      return a > b ? 1 : a < b ? -1 : 0;
    });

    this.levels_for_select = [];
    this.levels_list.map((lvl: any) => {
      if (!this.levels_for_select.includes(lvl.level)) {
        this.levels_for_select.push(lvl.level);
      }
    });
  }

  changeContract($event: any) {
    this.resetData(true);
    this.data.contract = $event.id;
    this.data.contract_name = $event.name;

    this.typeIsApprendistato = $event.name === "Apprendistato";
    this.typeIsStage = false;
    this.typeIsVatNumber = false;

    if ($event.name === "Stage") {
      this.levels_for_select = [];
      this.typeIsStage = true;
      this.data.net_monthly_12 = "800,00";
      this.data.gross_monthly_12 = "800,00";
      this.data.total_daily = "40,00";
      return false;
    }
    if ($event.name === "Partita IVA") {
      this.levels_for_select = [];
      this.typeIsVatNumber = true;
      this.data.total_daily = "50,00";
      return false;
    }

    setTimeout(() => this.getLevels());
  }

  changeLevel(fromInput: boolean = false, resetDates: boolean = true, update: boolean = true) {
    const lvlName = this.data.level;
    setTimeout(() => {
      switch (lvlName) {
        case "B3":
          const b3List: any = this.levels_list.filter((c: any) => c.level === lvlName);
          this.current_lvl = b3List[0];
          this.next_lvl = b3List[b3List.length - 1];
          break;
        default:
          this.current_lvl = this.levels_list.find((c: any, index: number) => {
            if (c.level === lvlName) {
              this.next_lvl = this.levels_list[index + 1];
              return c;
            }
          });
          break;
      }

      if (fromInput) {
        this.data.net_monthly_12 = 0;
        this.data.net_monthly_13 = 0;
        this.data.total_daily = 0;
        this.data.salary_yearly_gross = 0;
      }

      if (resetDates) {
        this.data.start_date = "";
        this.data.end_date = "";
      }

      if (update) {
        this.updateData();
      }
    });
  }

  async changeSalaryGrossYearly(value) {
    if (!this.levels_list || this.levels_list.length < 1) {
      this.getLevels();
    }

    if (typeof value === "string") {
      value = value.split("");
      if (value[2] === "." && value[value.length - 3] === ".") {
        delete value[2];
      }
      value = value.join("");
      if (value.includes(",")) {
        value = value.replace(",", ".");
      }
      value = Number(value);
    }

    if (!this.data.salary_yearly_gross.includes(".")) {
      this.data.salary_yearly_gross = this._utils.addDotsToNumber(this.data.salary_yearly_gross);
    }

    if (this.typeIsApprendistato) {
      const first: any = this.levels_list[0];
      const last: any = this.levels_list[this.levels_list.length - 1];

      // se la ral inserita è minore/uguale del primo livello impostiamo il primo livello
      if (value <= first.salary_yearly_gross) {
        this.data.level = first.level;
        await this.showPopupEditLevel("UP");
        this.changeLevel(false, false);
      }
      // se la ral inserita è maggiore/uguale dell'ultimo livello impostiamo l'ultimo livello
      else if (value >= last.salary_yearly_gross) {
        this.data.level = last.level;
        await this.showPopupEditLevel("DOWN");
        this.changeLevel(false, false);
      }
      // se la ral inserita è fra il primo e l'ultimo livello ci andiamo a cercare quello che più si avvicina alla ral inserita
      else {
        let currentLvl: any;
        this.levels_list.map(async (cost: any, i: number) => {
          if (!currentLvl && cost.salary_yearly_gross <= value && this.levels_list[i + 1].salary_yearly_gross >= value) {
            this.data.level = cost.level;
            currentLvl = cost;
          }
        });
        this.changeLevel(false, false, false);
        setTimeout(() => this.updateData("ral"));
      }
    } else {
      const costsList: any = !this.typeIsApprendistato ? this.levels_list : this.costs.filter((cost: any) => cost.is_apprendistato === 1 && cost.year === Number(this.contractDuration));

      const max: any = Number(costsList[costsList.length - 1].salary_yearly_gross);
      const min: any = Number(costsList[0].salary_yearly_gross);

      if (max <= value) {
        this.data.level = this.levels_list[this.levels_list.length - 1].level;
        const listValidLvl: any = this.costs.filter((c: any) => c.level == this.data.level && c.is_apprendistato === Number(this.typeIsApprendistato));
        this.current_lvl = listValidLvl[listValidLvl.length - 1];
        this.data.salary_yearly_gross = this._utils.addDotsToNumber(value);
        this.changeLevel(false, false, false);
        setTimeout(() => this.updateData("ral"));
      } else if (min >= value) {
        this.data.level = this.levels_list[0].level;
        this.changeLevel(false, false, false);
        setTimeout(() => this.updateData());
      } else {
        let founded: boolean = false;
        this.levels_list.map((cost: any, i: number) => {
          if (!founded && Number(cost.salary_yearly_gross) <= value && Number(this.levels_list[i + 1].salary_yearly_gross) >= value) {
            founded = true;
            this.data.level = cost.level;
            this.data.salary_yearly_gross = this._utils.addDotsToNumber(value);
            this.changeLevel(false, false, false);
            setTimeout(() => this.updateData("ral"));
          }
        });
      }
    }
  }

  public updateData(from: string = "") {
    if (this.typeIsStage || this.typeIsVatNumber) {
      if (this.typeIsVatNumber) {
        this.data.total_daily = Number(this.data.total_daily);
      } else {
        this.data.total_daily = Number(this.data.total_daily);
        this.data.net_monthly_12 = Number(this.data.net_monthly_12);
        this.data.gross_monthly_12 = this.data.net_monthly_12;
        this.data.total_daily = this.data.net_monthly_12 / 20;
      }
    } else {
      if (String(this.data.bonus).length < 1) {
        this.data.bonus = 0;
      }
      if (String(this.data.ticket_total).length < 1) {
        this.data.ticket_total = 0;
      }
      if (typeof this.data.ticket_total === "string") {
        this.data.ticket_total = this._utils.removeDotsFromNumber(this.data.ticket_total);
      }
      if (typeof this.data.bonus === "string") {
        this.data.bonus = this._utils.removeDotsFromNumber(this.data.bonus);
      }

      // quando fai un cambiamento dall'input della ral
      if (from === "ral") {
        const ral = this._utils.removeDotsFromNumber(this.data.salary_yearly_gross);

        // decido con che livello fare le proporzioni scegliendo quello più vicino alla ral impostata
        const theshold: number = Number(this.current_lvl.salary_yearly_gross) + (Number(this.next_lvl?.salary_yearly_gross) - Number(this.current_lvl?.salary_yearly_gross)) / 2;
        let lvlToCompare: any = ral > theshold ? this.next_lvl : this.current_lvl;

        if (this.current_lvl.level === "B3") {
          const b3List: any = this.costs
            .filter((c: any) => c.level === "B3" && c.is_apprendistato === Number(this.typeIsApprendistato))
            .sort((a: any, b: any) => {
              a = Number(a.salary_yearly_gross);
              b = Number(b.salary_yearly_gross);
              return a > b ? 1 : a < b ? -1 : 0;
            })
            .map((c: any) => {
              c.salary_yearly_gross = Number(c.salary_yearly_gross);
              return c;
            });

          if (ral >= b3List[b3List.length - 1].salary_yearly_gross - 1) {
            lvlToCompare = b3List[b3List.length - 1];
          } else {
            let currentLvlB3: any;
            let nextLvlB3: any;
            b3List.map((cost: any, i: number) => {
              if (!currentLvlB3 && cost.salary_yearly_gross <= ral && b3List[i + 1].salary_yearly_gross >= ral) {
                currentLvlB3 = cost;
                nextLvlB3 = b3List[i + 1];
              }
            });

            const theSholdB3: any = Number(currentLvlB3.salary_yearly_gross) + (Number(nextLvlB3.salary_yearly_gross) - Number(currentLvlB3.salary_yearly_gross)) / 2;
            lvlToCompare = ral > theSholdB3 ? nextLvlB3 : currentLvlB3;
          }
        }

        const newData: any = {};

        // retribuzione lorda mensile = ral / 12
        newData.gross_monthly_12 = ral / 12;
        // nuova_ral: nuovo_netto_12 = compare_ral: compare_netto_12
        newData.net_monthly_12 = (lvlToCompare.net_monthly_12 * ral) / lvlToCompare?.salary_yearly_gross;
        // nuova_ral: nuovo_netto_13 = compare_ral: compare_netto_13
        newData.net_monthly_13 = (lvlToCompare?.net_monthly_13 * ral) / lvlToCompare?.salary_yearly_gross;
        // nuova_ral: nuovo_totale_giornaliero = compare_ral: compare_totale_giornaliero
        newData.total_daily = (lvlToCompare?.total_daily * ral) / lvlToCompare?.salary_yearly_gross;

        this.data.ticket_value = this.data.ticket_total / 20;

        this.data.gross_monthly_12 = newData.gross_monthly_12;
        this.data.net_monthly_12 = newData.net_monthly_12;
        this.data.net_monthly_13 = newData.net_monthly_13;
        this.data.salary_yearly_gross = ral;
        this.data.total_daily = newData.total_daily + this.data.bonus / 20 + this.data.ticket_value;
      } else {
        const { currentLvl }: any = this.getLevelsData();

        this.data.salary_yearly_gross = currentLvl.salary_yearly_gross;
        this.data.gross_monthly_12 = this.data.salary_yearly_gross / 12;
        this.data.trial = currentLvl.trial;
        this.data.total_daily = currentLvl.total_daily;
        this.data.net_monthly_12 = currentLvl.net_monthly_12;
        this.data.net_monthly_13 = currentLvl.net_monthly_13;
        this.data.ticket_value = this.data.ticket_total / 20;
        this.data.total_daily = currentLvl.total_daily + this.data.bonus / 20 + this.data.ticket_value;
      }
      this.data.total_net_monthly_13 = this.data.net_monthly_13 + this.data.bonus;
    }

    this.addDots();
  }

  private async showPopupEditLevel(direction: string) {
    const message: any = await this._utils.translate("ALERT.WARNING_CHANGING_CONTRACT_LEVEL_" + direction);
    await this._toastService.info(message);
  }
}
